import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsEncyclopediaCategory } from 'types/cms/collection-types'

/**
 * Get the encyclopedia categories from the CMS
 *
 * @param {Language} locale
 * @returns {Promise<CmsEncyclopediaCategory[]>}
 */
const getEncyclopediaCategories = async (locale: Language = Language.DUTCH): Promise<CmsEncyclopediaCategory[]> => {
  try {
    const { data } = await axios.get<CMSApiResponseBody<CmsEncyclopediaCategory[]>>(
      `${process.env.CMS_API_URL}/encyclopedia-categories?locale=${locale}`
    )

    return data.data
  } catch (_) {
    return []
  }
}

export default getEncyclopediaCategories
